<template>
  <custom-dialog
    :openDialog="isOpen"
    :widthDialog="'700px'"
    :classDialog="'advance-search-dialog'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('dialogClosed')"
  >
    <template #body>
      <h3 class="dialogTitle">Tìm kiếm nâng cao</h3>
      <el-form :model="form" label-position="right">
        <el-row :gutter="12">
          <el-col :span="24">
            <el-form-item label="Trích yếu" class="formItem">
              <el-input
                v-model="advanceSearchForm.quote"
                v-focus.native
                class=""
                placeholder="-"
                size="medium"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="12">
          <el-col :span="24">
            <el-form-item label="Nội dung văn bản" class="formItem">
              <el-input
                v-model="advanceSearchForm.fileContent"
                v-focus.native
                class=""
                placeholder="-"
                size="medium"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="12">
          <el-col :span="24">
            <el-form-item label="Độ khẩn:" class="formItem">
              <el-select
                clearable
                class="style-fullWidth"
                v-model="advanceSearchForm.priorityId"
                filterable
                placeholder="-"
                size="medium"
              >
                <el-option
                  v-for="item in priorities"
                  :key="item.id"
                  :label="item.categoryName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="12">
          <el-col :span="24">
            <el-form-item label="Loại văn bản:" class="formItem">
              <el-select
                clearable
                class="style-fullWidth"
                v-model="advanceSearchForm.docTypeId"
                filterable
                placeholder="-"
                size="medium"
              >
                <el-option
                  v-for="item in docTypes"
                  :key="item.id"
                  :label="item.categoryName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="12">
          <el-col :span="24">
            <el-form-item label="" class="formItem">
              <template #label>
                <span class="flex-row flex__right">
                  Đơn vị ban hành: &nbsp;
                  <i
                    class="fas fa-cog advance-search color__cyan clickable"
                    @click="selectPublishId"
                  ></i>
                </span>
              </template>
              <el-select
                filterable
                clearable
                v-model="advanceSearchForm.publisherId"
                placeholder="-"
                class="style-fullWidth"
                size="medium"
                @change="publisherIdChange"
              >
                <el-option
                  v-for="item in publisherDepartments"
                  :label="item.deptName"
                  :key="item.id"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="12">
          <el-col :span="24">
            <el-form-item label="" class="formItem">
              <template #label>
                <span class="flex-row flex__right">
                  Nơi nhận bên trong &nbsp;
                  <i
                    class="fas fa-cog advance-search color__cyan clickable"
                    @click="selectReceiveDeptId"
                  ></i>
                </span>
              </template>
              <el-select
                filterable
                clearable
                v-model="advanceSearchForm.receiveDeptId"
                placeholder="-"
                class="style-fullWidth"
                size="medium"
              >
                <el-option
                  v-for="item in receiveDepartments"
                  :label="item.deptName"
                  :key="item.id"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="12">
          <el-col :span="24">
            <el-form-item
              label="Nơi nhận bên ngoài"
              prop="otherReceivePlaces"
              class="formItem"
            >
              <el-select
                v-model="advanceSearchForm.otherReceivePlaces"
                filterable
                allow-create
                default-first-option
                remote
                reserve-keyword
                :remote-method="remoteMethod"
                :loading="isLoading"
                class="style-fullWidth input-border__bottom input-border__radius__0"
                placeholder="Gõ để tìm kiếm đơn vị.."
              >
                <el-option
                  v-for="(item, index) in listInsideReceiver"
                  :key="index"
                  :label="item.deptName"
                  :value="item.deptName"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="12">
          <el-col :span="24">
            <el-form-item label="Ngày văn bản" class="formItem">
              <el-date-picker
                v-model="docDateRange"
                :picker-options="dateQuickFilterOption"
                type="daterange"
                range-separator=" - "
                start-placeholder="-"
                end-placeholder="-"
                align="bottom"
                format="dd/MM/yyyy"
                class="style-fullWidth"
                size="medium"
                @change="docDateRangeChange"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>
    <template #footer>
      <div class="flex-row flex__right form-button__action">
        <el-button class="dialogBtnPrimary" @click="search">
          <i class="fas fa-search font-size__small"></i>
          &nbsp;Tìm kiếm
        </el-button>
        <el-button class="btn__cancel btn-none__border" @click="reset"
        >Khởi tạo
        </el-button>
        <selectDepartmentDialog
          :isOpen="isOpenSelectDepartmentDialog"
          v-if="isEnableSelectDepartmentDialog"
          @closed="isEnableSelectDepartmentDialog = false"
          @closeDialog="isOpenSelectDepartmentDialog = false"
          @change="publisherDepartmentChange"
        >
        </selectDepartmentDialog>
      </div>
    </template>
  </custom-dialog>
</template>

<script>
  import h from "../../../services/h";
  import constants from "../../../constants";
  import categoryViewService from "../../../services/categoryViewService";
  import departmentService from "../../../services/departmentService";
  import otherDepartmentService from "../../../services/otherDepartmentService";
  import dateUtils from "../../../dateUtils";
  import utils from "../../../services/utils";

  export default {
    name: "banhanh-advance-search-dialog",
    props: ["isOpen", "form"],
    components: {
      customDialog: () => import("../../common/custom-dialog.vue"),
      selectDepartmentDialog: () =>
        import("../../common/commonSelectDepartmentDialog")
    },

    computed: {
      deptId() {
        return this.$store.getters.userDeptRole.deptId;
      }
    },

    data() {
      return {
        publisherDepartments: [],
        listInsideReceiver: [],
        isLoading: false,
        receiveDepartments: [],
        docTypes: [],
        departments: [],
        priorities: [],
        selectType: null,
        isOpenSelectDepartmentDialog: false,
        isEnableSelectDepartmentDialog: false,
        docDateRange: null,
        advanceSearchForm: {
          quote: null,
          fileContent: null,
          priorityId: null,
          docTypeId: null,
          publisherId: null,
          receiveDeptId: null,
          otherReceivePlaces: null,
          fromDocDate: null,
          toDocDate: null,
        },

        dateQuickFilterOption: utils.getDefaultDateQuickFilterOption(),
      };
    },

    watch: {
      isOpenSelectDepartmentDialog(newValue) {
        newValue && (this.isEnableSelectDepartmentDialog = newValue);
      }
    },

    created() {
      this.loadCategories();
      this.loadDepartments();
      this.initForm();
    },

    methods: {

      docDateRangeChange() {
        this.advanceSearchForm.fromDocDate =
          this.docDateRange && this.docDateRange[0]
            ? this.docDateRange[0].getTime()
            : undefined;
        this.advanceSearchForm.toDocDate =
          this.docDateRange && this.docDateRange[1]
            ? this.docDateRange[1].getTime()
            : undefined;
      },

      initForm() {
        this.advanceSearchForm.quote = this.form.quote;
        this.advanceSearchForm.fileContent = this.form.fileContent;
        this.advanceSearchForm.priorityId = this.form.priorityId;
        this.advanceSearchForm.docTypeId = this.form.docTypeId;
        this.advanceSearchForm.publisherId = this.form.publisherId;
        this.advanceSearchForm.receiveDeptId = this.form.receiveDeptId;
        this.advanceSearchForm.otherReceivePlaces = this.form.otherReceivePlaces;
        this.advanceSearchForm.fromDocDate = this.form.fromDocDate;
        this.advanceSearchForm.toDocDate = this.form.toDocDate;
        this.initDocDateRange();
      },

      initDocDateRange() {
        if (
          this.advanceSearchForm.fromDocDate ||
          this.advanceSearchForm.toDocDate
        ) {
          this.docDateRange = [
            dateUtils.toMoment(this.advanceSearchForm.fromDocDate),
            dateUtils.toMoment(this.advanceSearchForm.toDocDate)
          ];
        } else {
          this.docDateRange = dateUtils.getDatesByQuickFilter(
            constants.DATE_QUICK_FILTER.CODE.LAST_30_DAYS
          );
          let defaultTimeRange = dateUtils.getTimesByQuickFilter(
            constants.DATE_QUICK_FILTER.CODE.LAST_30_DAYS
          );
          this.advanceSearchForm.fromDocDate = defaultTimeRange[0];
          this.advanceSearchForm.toDocDate = defaultTimeRange[1];
        }
      },

      loadPublisherDepartments() {
        return departmentService.findParents(this.deptId).then(response => {
          this.publisherDepartments = response.data;
          let set = new Set();
          this.publisherDepartments.forEach(item => {
            departmentService
              .prepareReceiveDepartments(item.id, this.departments)
              .forEach(item => set.add(item));
          });
          this.receiveDepartments = Array.from(set);
        });
      },

      prepareReceiveDepartments(publisherId) {
        this.receiveDepartments = departmentService.prepareReceiveDepartments(
          publisherId,
          this.departments
        );
      },

      publisherIdChange() {
        //reset lại nơi nhận bên trong;
        this.form.receiveDeptId = null;
        this.prepareReceiveDepartments(this.form.publisherId);
      },

      remoteMethod(query) {
        if (query !== "") {
          this.findOtherDept(query);
        } else {
          this.options = [];
        }
      },

      findOtherDept(query) {
        this.isLoading = true;
        otherDepartmentService
          .search(query, this.deptId, {sort: "count,desc", page: 0, size: 20})
          .then(res => {
            this.listInsideReceiver = res.data;
            this.isLoading = false;
          });
      },
      selectPublishId() {
        this.isOpenSelectDepartmentDialog = true;
        this.selectType = "publish";
      },

      selectReceiveDeptId() {
        this.isOpenSelectDepartmentDialog = true;
        this.selectType = "receive";
      },

      publisherDepartmentChange(event) {
        let department = event.selectedDepartment;
        if (this.selectType === "publish")
          this.form.publisherId = department ? department.id : null;
        else this.form.receiveDeptId = department ? department.id : null;
        this.isOpenSelectDepartmentDialog = false;
      },

      loadCategories() {
        h.each(
          [
            constants.CATEGORY_GROUP_CODE.PRIORITY,
            constants.CATEGORY_GROUP_CODE.DOC_TYPE
          ],

          item => {
            categoryViewService
              .findAll(
                {groupCode: item},
                {sort: "order,asc", page: 0, size: 1000}
              )
              .then(response => {
                switch (item) {
                  case constants.CATEGORY_GROUP_CODE.PRIORITY:
                    return (this.priorities = response.data.filter(item => item.status !== "deactive"));

                  case constants.CATEGORY_GROUP_CODE.DOC_TYPE:
                    return (this.docTypes = response.data.filter(item => item.status !== "deactive"));
                }
              });
          }
        );
      },

      loadDepartments() {
        departmentService.findAll().then(response => {
          this.departments = response.data.filter((x) => x.id !== "ROOT");
          this.loadPublisherDepartments();
        });
      },

      search() {
        this.$emit("doSearch", {advanceSearchForm: this.advanceSearchForm});
        this.$emit("closeDialog");
      },

      reset() {
        this.advanceSearchForm.quote = null;
        this.advanceSearchForm.fileContent = null;
        this.advanceSearchForm.priorityId = null;
        this.advanceSearchForm.docTypeId = null;
        this.advanceSearchForm.publisherId = null;
        this.advanceSearchForm.receiveDeptId = null;
        this.advanceSearchForm.otherReceivePlaces = null;
        this.docDateRange = dateUtils.getDatesByQuickFilter(constants.DATE_QUICK_FILTER.CODE.LAST_30_DAYS);
        let defaultTimeRange = dateUtils.getTimesByQuickFilter(constants.DATE_QUICK_FILTER.CODE.LAST_30_DAYS);
        this.advanceSearchForm.fromDocDate = defaultTimeRange[0];
        this.advanceSearchForm.toDocDate = defaultTimeRange[1];
      }
    }
  };
</script>

<style scoped>
  .form {
    padding: 12px 20px 0 20px;
  }

  .filter {
    background-color: #d5d7dd;
    border-radius: 4px;
    padding: 13px 10px;
    margin-bottom: 10px;
  }

  .filter .item {
    color: #007aff;
    font-size: 15px;
    font-weight: 500;
    margin-right: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/views/doc-out/components/banhanh-advance-search-dialog.vue